import { type FC, useState } from "react";
import Modal from "@root/shared/components/Modal";
import * as styles from "./styles.css";

type Props = {
  promotionImagePath: string;
  lineQrImagePath: string;
  appQrImagePath?: string;
};

export const LineAppPromotionModal: FC<Props> = ({
  promotionImagePath,
  lineQrImagePath,
  appQrImagePath,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => {
    setIsOpen(false);
  };
  const handleOpen = () => {
    setIsOpen(true);
  };

  return (
    <>
      <button className={styles.promotionImageButton} onClick={handleOpen} type="button">
        <img
          src={promotionImagePath}
          alt={appQrImagePath ? "LINE/採用アプリで通知できます。" : "LINEで通知できます。"}
          className={appQrImagePath ? styles.lineAppPromotionImage : styles.linePromotionImage}
        />
      </button>
      <Modal
        headerTitle="スマートフォンで通知を受け取る"
        isShow={isOpen}
        onClose={handleClose}
        spAppearanceType="center"
        pcWidthType="large"
      >
        <div className={styles.qrImageAreaWrapper}>
          <div className={styles.qrImageArea}>
            <img src={lineQrImagePath} alt="いつものLINEで通知" className={styles.qrImage} />
            {appQrImagePath && (
              <img
                src={appQrImagePath}
                alt="アプリでもっと採用の効率化"
                className={styles.qrImage}
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};
